import PhotoBanner from "./PhotoBanner";
import NoPhotoBanner from "./Theme1/NoPhotoBanner";
import Theme2NoPhotoBanner from "./Theme2/Theme2NoPhotoBanner";
import Theme3NoPhotoBanner from "./Theme3/Theme3NoPhotoBanner";
import Theme4NoPhotoBanner from "./Theme4/Theme4NoPhotoBanner";
import Theme5NoPhotoBanner from "./Theme5/Theme5NoPhotoBanner";

const BannerPreview = ({ values, theme }) => {

  if (values.bannerType === "photo") {
    return <PhotoBanner values={values} />;
  }

  if (theme === "theme1") {
    return <NoPhotoBanner values={values} />;
  }

   if (theme === "theme2") {
    return <Theme2NoPhotoBanner values={values} />;
  }

    if (theme === "theme3") {
    return <Theme3NoPhotoBanner values={values} />;
  }

     if (theme === "theme4") {
    return <Theme4NoPhotoBanner values={values} />;
  }


      if (theme === "theme5") {
    return <Theme5NoPhotoBanner values={values} />;
  }


  return null;
};

export default BannerPreview;